import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import {
	UkSurgingPetitionToastExperiment,
	UkSurgingPetitionToastPetition as UkSurgingPetitionToastPetitionQ,
} from './api.graphql';
import type {
	UkSurgingPetitionToastExperimentQuery,
	UkSurgingPetitionToastExperimentQueryVariables,
	UkSurgingPetitionToastPetitionQuery,
	UkSurgingPetitionToastPetitionQueryVariables,
} from './api.graphql';

type UkSurgingPetitionToastExperimentAssignment =
	UkSurgingPetitionToastExperimentQuery['experiments']['ukSurgingPetitionToast'];

export type UkSurgingPetitionToastPetition = NonNullable<UkSurgingPetitionToastPetitionQuery['petition']>;

const ONE_DAY_IN_MS = 24 * 60 * 60 * 1000;

export const UK_SURGING_PETITION_TOAST_EXPERIMENT_QUERY_KEY = 'UK_SURGING_PETITION_TOAST_EXPERIMENT';
export const UK_SURGING_PETITION_TOAST_PETITION_QUERY_KEY = 'UK_SURGING_PETITION_TOAST_PETITION';

export async function fetchUkSurgingPetitionToastExperiment(
	utilityContext: UtilityContext,
): Promise<UkSurgingPetitionToastExperimentAssignment> {
	const {
		gql: { fetch },
	} = utilityContext;
	const { data } = await fetch<UkSurgingPetitionToastExperimentQuery, UkSurgingPetitionToastExperimentQueryVariables>({
		query: UkSurgingPetitionToastExperiment,
		rejectOnError: false,
	});

	if (!data) {
		throw new Error('uk_surging_petition_toast: experiment assignment not found');
	}

	return data.experiments.ukSurgingPetitionToast;
}

export async function fetchUkSurgingPetitionToastPetition(
	utilityContext: UtilityContext,
	{ slug }: { slug: string },
): Promise<UkSurgingPetitionToastPetition | null> {
	const {
		gql: { fetch },
	} = utilityContext;
	// Trailing 1-day window for the momentum stat, computed at fetch time (per spec).
	const createdAfter = new Date(Date.now() - ONE_DAY_IN_MS).toISOString();
	const { data } = await fetch<UkSurgingPetitionToastPetitionQuery, UkSurgingPetitionToastPetitionQueryVariables>({
		query: UkSurgingPetitionToastPetitionQ,
		variables: { slug, createdAfter },
		rejectOnError: false,
	});

	return data?.petition ?? null;
}
